import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Login } from "../Pages/Login";
import { LandingPage } from "../Pages/LandingPage";
import { LoginLandingPage } from "../Pages/LoginLanding";
import { Home } from "../Pages/Home";
import ProtectedRoute from "../RouterPath/protectedRoute";
import { SalesBoard } from "../Pages/SalesBoard";
import { Users } from "../Pages/Users";
import { Dashboard } from "../Pages/Dashboard";
import { Leads } from "../Pages/Leads";
import { Contacts } from "../Pages/Contacts";
import PrivacyPolicy from "../Pages/Privacy";
import TermsAndConditions from "../Pages/TermsAndCondition";
import { Companies } from "../Pages/Companies";
import Opportunities from "../Pages/Opportunities";
import Quotations from "../Pages/Quotations";
import { Tasks } from "../Pages/Tasks";
import { Meetings } from "../Pages/Meetings";
import { Activities } from "../Pages/Activities";
import { Reports } from "../Pages/Reports";
import { Administration } from "../Pages/Administration";

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {}
    };
    window.addEventListener("storage", handleInvalidToken);
    return () => window.removeEventListener("storage", handleInvalidToken);
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Routes */}
          <Route path="/" element={<LoginLandingPage />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/salesboard" element={<SalesBoard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/quotations" element={<Quotations />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/administration" element={<Administration />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default RoutePath;

